import { useCallback } from 'react';
import partExchangeTransformer from '../../common/service/partExchangeTrasformer';
import numberUtilities from '../../../../common/utilities/numberUtilities';
import { useDispatch, useSelector } from 'react-redux';
import { currentDealActions } from '../store/reducers/currentDealReducer';
import CalculatorEvents from '../../common/constants/calculatorEvents';
import { IApproveFinanceData } from '../../common/model/IApproveFinanceData';
import currentDealSelectors from '../store/selectors/currentDealSelectors';
import { IFinanceCalculatorCustomiseWidget } from '../components/customiseContainer/financeCalculator/FinanceCalculatorCustomiseWidget';
import usePlatformConfig from '../../common/react/usePlatformConfig';
import { partExchangeActions } from '../store/reducers/partExchangeReducer';

interface IUseFinCalcCustomisePayload {
  postInitialization?: (widgetInstance: any, widgetId: string) => void;
  isDealLoading: boolean;
}

type TUseFinCalcConfigurator = (props: IFinanceCalculatorCustomiseWidget) => IUseFinCalcCustomisePayload;

export const useFinCalcCustomise: TUseFinCalcConfigurator = ({ toggleModal }) => {
  const isDealLoading = useSelector(currentDealSelectors.getLoadingStatus);
  const {
    platformConfig: { priceDisplay },
  } = usePlatformConfig();
  const dispatch = useDispatch();

  const destroyFinCalcWidget = useCallback(widgetId => {
    toggleModal(false);
    (window as any).FC.InchcapeFinance.destroy(`#${widgetId}`);
  }, []);

  const postInitialization = useCallback((widgetInstance, widgetId) => {
    widgetInstance.on(CalculatorEvents.CONTINUE, (plainQuote: IApproveFinanceData) => {
      const { financeQuote, partExchange, fullProductConfiguration } = plainQuote.activeDeal;
      const { setPartExchange, setPartExchangeValuation } = partExchangeActions;
      const { setTotalAmountPayable, setFinanceQuote, setDeposit } = currentDealActions;

      destroyFinCalcWidget(widgetId);
      dispatch(setFinanceQuote(financeQuote));

      dispatch(
        setTotalAmountPayable({
          carPrices: fullProductConfiguration.prices,
          priceDisplay,
          financeDeposit: financeQuote.deposit,
          options: fullProductConfiguration.options,
        }),
      );

      dispatch(setPartExchange(partExchange));

      dispatch(
        currentDealActions.setTotalAmountPayable({
          carPrices: plainQuote.activeDeal.fullProductConfiguration.prices,
          priceDisplay,
          financeDeposit: plainQuote.activeDeal.financeQuote.deposit,
          options: plainQuote.activeDeal.fullProductConfiguration.options,
        }),
      );

      if (partExchange && numberUtilities.isNumber(partExchangeTransformer.extractValuationPrice(partExchange))) {
        dispatch(setPartExchangeValuation(partExchangeTransformer.extractValuationPrice(partExchange)));
      } else {
        dispatch(setPartExchangeValuation(null));
      }

      if (financeQuote?.deposit) {
        dispatch(setDeposit(financeQuote.deposit));
      } else {
        dispatch(setDeposit(0));
      }
    });
  }, []);

  return { postInitialization, isDealLoading };
};
